
















import { Component, Vue } from "vue-property-decorator";
import Card from "@/components/Card.vue";

@Component({
  components: {
    Card,
  },
})

export default class CategoryList extends Vue {
  name = "categoryList"
  get type() {
    return this.$store.state.categoryType;
  }
  get meals() {
    return this.$store.state.mealsBasedOnCategory;
  }
  created() {
    // Get category type that was chosen and passed into route param
    const { type } = this.$route.params;
    this.$store.commit('setCategoryType', type)
    // Get list of meals based on category
    this.$store.dispatch('getMealsBasedOnCategory');
  }
}

